// extracted by mini-css-extract-plugin
export var active = "_9f-d";
export var blink = "_9f-e";
export var container = "_9f-5";
export var controls = "_9f-0";
export var controlsRight = "_9f-1";
export var fakeCursor = "_9f-c";
export var hidden = "_9f-b";
export var quillContainerSmall = "_9f-7";
export var quillEditor = "_9f-6";
export var quillEditorSmall = "_9f-8";
export var quillFormatButtons = "_9f-a";
export var quillToolbar = "_9f-9";
export var removePadding = "_9f-2";
export var state = "_9f-3";
export var stateTitle = "_9f-4";